import React, { useState, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom';

const Hotspots = (props) => {
   const { menuList, hotspotData } = props;

   // const [windWidth, winHeight] = useWindowSize();
   // const withOutArrowId = ["screen", "rear", "rearPorts", "height", "swivel", "tilt", "slant"];
   //    const withOutArrowId = [];
   //    const hasRadioButton = subMenuList.some(item => item.menuType === "radioButton");

   /*Menu List */
   // console.log('Hotspots called----', menuList);
   let subMenuListArr = [];

   menuList.forEach(menu => {
      subMenuListArr.push(menu.items)
   });

   let subMenuList = subMenuListArr.flat();
   // console.log('subMenuList----', subMenuList);
   /*Menu List */


   /*HotspotData */
   // console.log('hotspotData----', hotspotData);
   let hotspotDataKeys = Object.keys(hotspotData);
   let hotspotDataArray = [];
   // console.log('hotspotDataKeys ', hotspotDataKeys);
   hotspotDataKeys.forEach(keyName => {
      // console.log(hotspotData[element]);
      hotspotData[keyName].forEach(subElement => {
         // console.log('subElement ', subElement)
         subElement['hsParentType'] = keyName;
         hotspotDataArray.push(subElement);
      });
   });
   // console.log('hotspotDataArray----', hotspotDataArray);
   /*HotspotData */
   return (
      hotspotDataArray.map((hotspot) => {
         // let popupId = hotspot.popupId;

         let list = subMenuList.find(subMenu => subMenu.popupId === hotspot.popupId);
         // console.log('list ', list.popupHeading);
         return (
            ReactDOM.createPortal(<div onKeyDown={(e) => {
               if (e.key !== 'Enter') {
                  return
               } props.handleMenuClick(list)
            }} onClick={(event) => {
               props.handleMenuClick(list)
            }} id={hotspot.hsname} className={"calloutbox popupbox tempHotspot hsParentType_" + hotspot.hsParentType} data-info={JSON.stringify(hotspot)}>
               <div className="hotspots btn-pulse" id="hotspot_circle">

                  <span className="ring">
                     <span className="ring">
                        <span className="ring">
                           <span className="ring"></span>
                        </span>
                     </span>
                  </span>
                  {/* <span id="viewcontent" className="circle collapsible popuptogglebtn">
                     <p>i</p>
                  </span> */}
                  {/* <h3 className='hotspotHeading' style={{ opacity: "0" }}>{list.popupHeading}</h3> */}
               </div>
            </div>, document.getElementById('calloutbox_wrapper'))
         )
      })
   )
}

export default Hotspots